/* eslint-disable @typescript-eslint/no-explicit-any */

export function addPackageToWindowFrontiers(packageInfo: any) {
  if (process.browser) {
    if (!window.FRONTIERS) window.FRONTIERS = {};
    Object.assign(window.FRONTIERS, {
      [packageInfo.name]: packageInfo.version,
      dependencies: packageInfo.dependencies,
      devDependencies: packageInfo.devDependencies
    });
  }
}
